/* SOURCE MODE — isolated collection hover previews, interaction-loaded */
if (!customElements.get('source-card-hover')) {
  class SourceCardHover extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.source-hover-grid-card');
      this.cardInner = this.closest('.card__inner');
      this.mainImage = this.card?.querySelector('.card__media .media > img:first-child');
      this.buttons = Array.from(this.querySelectorAll('.source-card-hover-preview'));

      if (!this.card || !this.cardInner || !this.mainImage || !this.buttons.length) return;

      this.defaultSrc = this.mainImage.getAttribute('src') || '';
      this.defaultSrcset = this.mainImage.getAttribute('srcset') || '';
      this.defaultButton =
        this.querySelector('[data-default-preview="true"]') ||
        this.buttons[0];

      this.thumbnailsLoaded = false;

      this.buttons.forEach((button) => {
        button.addEventListener('pointerenter', () => this.showPreview(button));
        button.addEventListener('focus', () => {
          this.loadThumbnails();
          this.showPreview(button);
        });

        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
        });

        button.addEventListener('pointerdown', (event) => {
          event.stopPropagation();
        });
      });

      /* Only start fetching small thumbnail images once this card is explored. */
      this.cardInner.addEventListener('pointerenter', () => this.loadThumbnails(), { passive: true });
      this.cardInner.addEventListener('pointerleave', () => this.restoreDefault(), { passive: true });

      this.setActive(this.defaultButton);
    }

    loadThumbnails() {
      if (this.thumbnailsLoaded) return;
      this.thumbnailsLoaded = true;

      this.querySelectorAll('img[data-thumb-src]').forEach((img) => {
        const src = img.dataset.thumbSrc;
        if (!src) return;
        img.src = src;
        img.removeAttribute('data-thumb-src');
      });
    }

    showPreview(button) {
      const src = button.dataset.previewSrc;
      if (!src) return;

      this.card.classList.add('source-preview-active');
      this.mainImage.removeAttribute('srcset');
      this.mainImage.src = src;
      this.setActive(button);
    }

    setActive(activeButton) {
      this.buttons.forEach((button) =>
        button.classList.toggle('is-active', button === activeButton)
      );
    }

    restoreDefault() {
      this.card.classList.remove('source-preview-active');
      this.mainImage.src = this.defaultSrc;

      if (this.defaultSrcset) {
        this.mainImage.setAttribute('srcset', this.defaultSrcset);
      } else {
        this.mainImage.removeAttribute('srcset');
      }

      this.setActive(this.defaultButton);
    }
  }

  customElements.define('source-card-hover', SourceCardHover);
}
